
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"#000"}},[_c('path',{attrs:{"d":"M17.18 20.38a.75.75 0 01-.649.743l-.101.007H5.115a.75.75 0 01-.102-1.493l.102-.007H16.43a.75.75 0 01.75.75z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M10.367 24.102a.75.75 0 01-.916 1.183l-.088-.068-4.75-4.28a.75.75 0 01.916-1.182l.088.068 4.75 4.28z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M10.423 15.552a.75.75 0 01.02.98l-.077.08-4.736 4.253a.75.75 0 01-1.079-1.036l.077-.08 4.736-4.254a.75.75 0 011.06.057z","vector-effect":"non-scaling-stroke"}}),_c('g',[_c('path',{attrs:{"d":"M14.82 11.62a.75.75 0 01.649-.743l.101-.007h11.315a.75.75 0 01.102 1.493l-.102.007H15.57a.75.75 0 01-.75-.75z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M21.633 7.898a.75.75 0 01.916-1.183l.088.068 4.75 4.28a.75.75 0 01-.916 1.182l-.088-.068-4.75-4.28z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M21.577 16.448a.75.75 0 01-.02-.98l.077-.08 4.736-4.253a.75.75 0 011.079 1.036l-.077.08-4.736 4.254a.75.75 0 01-1.06-.057z","vector-effect":"non-scaling-stroke"}})])])])])
          )
        }
      }
    